import * as Audio from './audioAds/externals';
import * as DisplayAds from './displayAds/externals';
import * as Rewards from './rewards/externals';
import * as Video from './videoAds/externals';

export const Actions = Object.freeze({
  AD_OPPORTUNITY: 'AD_OPPORTUNITY',
  AD_REQUEST_IN_FLIGHT: 'AD_REQUEST_IN_FLIGHT',
  CLEAR_PA_VIDEO_STATS: 'CLEAR_PA_VIDEO_STATS',
  HANDLE_TILE: 'HANDLE_TILE',
  SET_EXTERNAL_AD_IDENTIFIERS: 'SET_EXTERNAL_AD_IDENTIFIERS',
  SET_PA_VIDEO_STATS: 'SET_PA_VIDEO_STATS',
  LOG_APS_MM4_EXPOSURE_EVENT: 'LOG_APS_MM4_EXPOSURE_EVENT',
});

export const AdLifecycleActions = Object.freeze({
  AD_LIFECYCLE_AD_OPPORTUNITY_END: 'ad_lifecycle_ad_opportunity_end',
  AD_LIFECYCLE_AD_OPPORTUNITY_ERROR: 'ad_lifecycle_ad_opportunity_error',
  AD_LIFECYCLE_AD_OPPORTUNITY_START: 'ad_lifecycle_ad_opportunity_start',
});

export const LifeCycleType = Object.freeze({
  AUDIO: 'audio',
  VIDEO: 'video',
});

export const AdAnalyticsKeys = Object.freeze([
  'action',
  'reason',
  'station_id',
  'trigger_action',
  'status',
]);

export { Audio, DisplayAds, Rewards, Video };
